import React from "react";
import { Container } from "react-bootstrap";
import headerBgSrc from "../assets/bg.png"; // Import the default background image

const PageHeader = ({ seoData }) => {
  const backgroundImage = seoData.og_image || headerBgSrc;

  return (
    <Container fluid className="py-2 fade-in">
      <div
        className="page-hero text-center d-flex flex-column justify-content-center align-items-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.8), rgba(0,0,0,0.8)), url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center top",
          minHeight: "50vh",
          padding: "3rem 1rem",
          color: '#ffffff', // Force text color to white
        }}
      >
        {/* Ensure child elements also inherit white color */}
        <h1 className="display-3 fw-bold mb-3" style={{ color: 'inherit' }}>{seoData.title}</h1>
        <p className="lead fs-5 mx-auto" style={{ maxWidth: "700px", color: 'inherit' }}>
          {seoData.meta_description}
        </p>
      </div>
    </Container>
  );
};

export default PageHeader;
